import * as common from './common.json';

export const ptBr = {
  common,
};
